import { Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { CommonInputControlDirective } from 'app/shared/directives/control/common-input-control.directive';

@Component({
  selector: 'kh-switch',
  styleUrls: ['./switch.component.less'],
  templateUrl: './switch.component.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SwitchComponent),
    multi: true
  }],
  standalone: false
})

export class SwitchComponent extends CommonInputControlDirective {
  @Input() public testId = 'switch-checkbox';
  @Output() public isChecked = new EventEmitter<boolean>();

  public emitSwitchValue(value: Event): void {
    this.isChecked.emit((value.target as HTMLInputElement).checked);
  }
}
